import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput,
  TabbedForm,
  FormTab
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";

const AreainfoForm = props => {
  const { record } = props;
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <TabbedForm {...props}>
      <FormTab label="areainfo.tab.name">
        <TextInput source="name" label="ชื่อภาษาไทย" validate={[required()]} />
        <TextInput source="name_en" label="ชื่อภาษาอังกฤษ" validate={[required()]} />
        <TextInput source="name_jp" label="ชื่อภาษาญี่ปุ่น" validate={[required()]} />
        <TextInput source="name_zh" label="ชื่อภาษาจีน" validate={[required()]} />
      </FormTab>

      <FormTab label="areainfo.tab.description">
        <LongTextInput source="description" label="รายละเอียดภาษาไทย" validate={[required()]} />
        <LongTextInput source="description_en" label="รายละเอียดภาษาอังกฤษ" validate={[required()]} />
        <LongTextInput source="description_jp" label="รายละเอียดภาษาญี่ปุ่น" validate={[required()]} />
        <LongTextInput source="description_zh" label="รายละเอียดภาษาจีน" validate={[required()]} />
      </FormTab>

      <FormTab label="areainfo.tab.other">
        <ReferenceInput
          disabled={record.project ? true : false}
          validate={[required()]}
          source="project"
          reference="project"
          filter={filter}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ImageInput
          multiple={false}
          validate={[required()]}
          source="image"
          accept="image/*"
        >
          <ImageField source="url" title="title" />
        </ImageInput>
      </FormTab>
    </TabbedForm>
  );
};

export default AreainfoForm;



// WEBPACK FOOTER //
// ./src/components/areainfo/AreainfoForm.js